import React from 'react';

import TextUI from './Text';

const Text = (props) => {
    return <TextUI { ...props } /> 
}

export default Text;